import type { PatientDetail } from "@care-by-ella/contracts";
import { doctorDesiredSupport } from "@/lib/doctor-desired-support";

// TES-1322 — her desired support as her own stated wish, for the doctor.
//
// Self-contained so any doctor view can mount it with the patient's `f01`
// block: neutral styling (not the flag/warning palette), its own section,
// never inside the AI panel or the journal prefill. Renders nothing for an
// F-01 that never asked (v10 and earlier).
export function DoctorDesiredSupportSection({
  f01,
}: {
  f01: PatientDetail["f01"] | undefined;
}) {
  const view = doctorDesiredSupport(f01);
  if (!view) return null;
  return (
    <section
      aria-labelledby="doctor-desired-support-heading"
      className="bg-surface border border-surfaceMuted rounded-md p-md"
    >
      <h2
        id="doctor-desired-support-heading"
        className="font-display text-lg mb-xs"
      >
        Patientens önskade stöd (patientens eget önskemål)
      </h2>
      <p className="text-xs text-textSecondary mb-sm">
        {view.provenance} • ett uttryckt önskemål om stöd, inte ett medicinskt
        fynd eller en indikation
      </p>
      <ul className="flex flex-col gap-xs text-sm">
        {view.labels.map((label) => (
          <li key={label}>{label}</li>
        ))}
        {view.other ? (
          <li className="text-textSecondary">Annat: {view.other}</li>
        ) : null}
      </ul>
    </section>
  );
}
